module.exports = __webpack_public_path__ + "603ba84ab5d168c8f020e0d2992d6f6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/page-footer/page-png/footer-border.png
// module id = ./src/components/page-footer/page-png/footer-border.png
// module chunks = index